export const EDIT_VERSION_LOADING = 'EDIT_VERSION_LOADING';
export const EDIT_VERSION_LOADED = 'EDIT_VERSION_LOADED';
export const EDIT_VERSION_ERROR = 'EDIT_VERSION_ERROR';
export const EDIT_VERSION_RESET = 'EDIT_VERSION_RESET';

export const GET_VERSION_LOADING = 'GET_VERSION_LOADING';
export const GET_VERSION_LOADED = 'GET_VERSION_LOADED';
export const GET_VERSION_ERROR = 'GET_VERSION_ERROR';
